import React from 'react';
import { Row, Col, Typography, Button, Image } from 'antd';
import { Link } from 'react-router-dom';
import LinkagesImage from '../../Assets/Home/Linkages-Outreach-Circle.png';
import '../../Styles/HomeStyles.css';

const { Title, Paragraph } = Typography;

const LinkagesOutreach = () => {
  return (
    <section className="linkages-section">
      <div className="home-section-shell">
        <Row gutter={[64, 40]} justify="space-between" align="middle">
          <Col xs={24} md={14} lg={14}>
            <Title level={2} className="linkages-title">Linkages &amp; Capacity Building</Title>
            <div className="section-underline" aria-hidden="true"></div>
            <Paragraph className="linkages-description">
            At NCGSA, every collaboration within the space sector is important for us.
            We believe it is only cooperation, coordination and collaboration through
            which increasing number of amateurs, scientists and researchers get a chance
            to interact and benefit from each other. Since its inception, NCGSA has aimed
            to build synergistic and mutually beneficial linkages with academia and industry
            related with space science technology and its application.
          </Paragraph>
            <Button type="primary" size="large" className="linkages-button">
              <Link to="/linkages">Linkages &amp; Capacity Building</Link>
            </Button>
          </Col>

          <Col xs={24} md={10} lg={10}>
            <div className="linkages-image-wrap">
              <Image preview={false} src={LinkagesImage} alt="Connected network across North America" className="linkages-image" />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default LinkagesOutreach;
